import BaseModel from "../default/base-model";
import {Project} from "./project";
import {Client} from "./client";
import {ProjectSummaryCategory} from "./project-summary-category";

export class AssetControl extends BaseModel {
    active: boolean;
    amortized_items: number;
    client: Client;
    cpu: number;
    created_at: string;
    fct: number;
    ict: number;
    id: number;
    lob: Lob;
    mao_frt: number;
    mao_tax: number;
    memory: number;
    modified_at: string;
    open_nre: number;
    other: number;
    project: Project;
    samples: number;
    spare: number;
    tooling: number;
    total: number;
    total_amortized: number;
    total_nre: number;
    url: string;
    categories: ProjectSummaryCategory[];

    constructor() {
        super();
        this.active = true;
        this.amortized_items = 0;
        this.client = new Client();
        this.cpu = 0;
        this.created_at = "";
        this.fct = 0;
        this.ict = 0;
        this.id = 0;
        this.lob = new Lob();
        this.mao_frt = 0;
        this.mao_tax = 0;
        this.memory = 0;
        this.modified_at = "";
        this.open_nre = 0;
        this.other = 0;
        this.project = new Project();
        this.samples = 0;
        this.spare = 0;
        this.tooling = 0;
        this.total = 0;
        this.total_amortized = 0;
        this.total_nre = 0;
        this.url = "";
        this.categories = [];
    }
}

export class Lob {
    active: boolean;
    id: number;
    name: string;

    constructor() {
        this.active = true;
        this.id = 0;
        this.name = "";
    }
}
